import { setupWorker } from 'msw/browser'
import { testHandlers } from './handlers'

export const worker = setupWorker(...testHandlers)
